import { useState } from "react";
import { Modal } from "react-bootstrap";
import { LoadingContainer } from "../../components/loading-container";

export interface Props {
    onClose: () => void;
    url: string;
}

export function JotFormDialog({ url, onClose }: Props) {
    const [loading, setLoading] = useState(true);
    const hideLoading = () => {
        setLoading(false);
    };

    return (
        <Modal show scrollable size="xl" onHide={onClose} backdrop="static">
            <Modal.Header closeButton />
            <Modal.Body>
                {loading ? <LoadingContainer /> : ""}
                <iframe
                    src={url}
                    title="jotform"
                    onLoad={hideLoading}
                    allowFullScreen
                    allow="geolocation; microphone; camera"
                    frameBorder="0"
                    className="width-100 heigth-500 border-none"
                />
            </Modal.Body>
        </Modal>
    );
}
